const PROD_API_BASE_URL = "https://www.lycomms.com/appv2/";
const TEST_API_BASE_URL = "https://test.lycomms.com/appv2/";
const STAGING_API_BASE_URL = "https://staging.lycomms.com/appv2/";
const DEV_API_BASE_URL = "http://localhost:8000/lycomms/appv2/";

class ApiService {

  constructor() {
    if (window.location.hostname === 'app.lycomms.com')
      this.api_url = PROD_API_BASE_URL;
    else if (window.location.hostname === 'app-test.lycomms.com')
      this.api_url = TEST_API_BASE_URL;
    else if (window.location.hostname === 'app-staging.lycomms.com')
      this.api_url = STAGING_API_BASE_URL;
    else
      this.api_url = DEV_API_BASE_URL;
  }

  async fetchData() {
    const requestOptions = {
      method: 'GET',
      credentials: 'include'
    };
    
    try {
      const response = await fetch(this.api_url + 'getdata.json', requestOptions);
      
      if (!response.ok) {
        console.error(`fetchData => HTTP error! status: ${response.status}`);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (err) {
      console.error('fetchData => error:', err);
      throw err; // Re-throw to let calling code handle it
    }
  }

  async postData(batch) {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      credentials: 'include',
      body: JSON.stringify(batch)
    };
  
    try {
      const response = await fetch(this.api_url + 'processone.json', requestOptions);
      
      if (!response.ok) {
        console.error(`postData => HTTP error! status: ${response.status}`);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data.results || [];
    } catch (error) {
      console.error('postData => batch failed:', error);
      throw error; // Re-throw instead of returning null
    }
  }

  async verifyAccessKey(accessKey) {
    if (!accessKey) {
      return false;
    }
    
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      credentials: 'include',
      body: JSON.stringify({
        "access_key": accessKey
      })
    };

    try {
      const response = await fetch(this.api_url + 'verifykey.json', requestOptions);
      
      if (!response.ok) {
        console.error(`verifyAccessKey => HTTP error! status: ${response.status}`);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (err) {
      console.error('verifyAccessKey => error:', err);
      throw err; // Re-throw to let calling code handle it
    }
  }

  async ping() {
    try {
      const response = await fetch(this.api_url + 'ping');
      
      if (!response.ok) {
        console.error(`ping => HTTP error! status: ${response.status}`);
        return false;
      }
      
      return await response.json();
    } catch (err) {
      console.error('ping => error:', err);
      return false; // Return false on network errors for ping
    }
  }
}

export default new ApiService();